module.exports = __webpack_public_path__ + "img/jjfa.0f664ddc.png";